import { component } from "picoapp";
import type A11yDialog from "a11y-dialog";
import { ajaxCartAdd, ajaxCartUpdate } from "../../../utilities/cart";

const REBUY_SWITCH_TO_SUBSCRIPTION_DIALOG =
  "rebuy:switch-to-subscription-dialog";

export const switchToSubscriptionDialog = component(
  (node: HTMLElement, context) => {
    const dialogId = node.dataset.dialogId;
    const getDialog = () => {
      return context.getState().dialogs[dialogId];
    };
    const sellingPlanId = node.dataset.sellingPlanId;

    const dialog = getDialog();

    const subscribeToRebuyEvents = (_dialog: A11yDialog) => {
      if (!_dialog) return;

      _dialog.on("hide", (event: CustomEvent) => {
        // Hide the smart cart along only if the dialog is hidden by native dialog events - click overlay, click close button, etc.
        window.igEvents = window.igEvents || [];
        window.igEvents.push({
          event: "Subscription Close",
          properties: {
            id: node.dataset.dialogId,
          },
        });
        if (window.Rebuy.SmartCart.visible && event.detail) {
          window.Rebuy.SmartCart.hide();
        }
      });

      _dialog.on("show", () => {
        window.igEvents = window.igEvents || [];
        window.igEvents.push({
          event: "Subscription Modal - Open",
          properties: {
            product: node.dataset.dialogId,
          },
        });
      });
    };

    if (dialog) {
      subscribeToRebuyEvents(dialog);
    } else {
      context.on("*", () => {
        const dialog = getDialog();
        if (dialog) {
          subscribeToRebuyEvents(dialog);
        }
      });
    }

    const shouldDialogRender = (e: CustomEvent): boolean => {
      if (window.disableSwitchToSubscriptionDialog === true) return false;
      if (!window.location.pathname.includes("/products")) return false;
      const firstItemAdded = e.detail.item.items
        ? e.detail.item.items[0]
        : e.detail.item;
      const variantId = node.dataset.variantId;
      if (!firstItemAdded || !firstItemAdded.id) return false;
      if (parseInt(variantId) !== parseInt(firstItemAdded.id)) return false;
      if (e.detail.item.selling_plan_allocation) return false;
      if (localStorage.getItem(REBUY_SWITCH_TO_SUBSCRIPTION_DIALOG)) {
        return false;
      }

      const cart = e.detail?.cart?.cart;
      const subscriptionVariant = cart.items.find((_item) => {
        return (
          _item.variant_id === e.detail.item.variant_id &&
          _item.selling_plan_allocation
        );
      });
      if (subscriptionVariant) return false;
      return true;
    };

    const renderDialogContent = async (e: CustomEvent) => {
      // validate cart
      if (!shouldDialogRender(e)) return;

      const dialog = getDialog();

      const firstItemAdded = e.detail.item.items
        ? e.detail.item.items[0]
        : e.detail.item;
      if (!firstItemAdded || !firstItemAdded.id) return;
      if (dialog) {
        dialog.show();
        localStorage.setItem(REBUY_SWITCH_TO_SUBSCRIPTION_DIALOG, "true");
      }
      // Handle Button Events
      const updateProductButton = node.querySelector(
        "#switch-to-subscription-dialog-button"
      );
      updateProductButton.addEventListener("click", async () => {
        await ajaxCartUpdate({
          [firstItemAdded.key]:
            firstItemAdded.quantity > 1 ? firstItemAdded.quantity - 1 : 0,
        });

        await ajaxCartAdd([
          {
            id: firstItemAdded.variant_id,
            quantity: 1,
            selling_plan: sellingPlanId,
            properties: firstItemAdded.properties,
          },
        ]);

        window.igEvents = window.igEvents || [];
        window.igEvents.push({
          event: "Subscription Modal - Accept",
          properties: {
            product: node.dataset.dialogId,
          },
        });

        dialog.hide();
      });
      const closeButton = node.querySelector(
        "#switch-to-subscription-dialog-close"
      );
      closeButton.addEventListener("click", () => {
        dialog.hide();
        window.igEvents = window.igEvents || [];
        window.igEvents.push({
          event: "Subscription Modal - Decline",
          properties: {
            product: node.dataset.dialogId,
          },
        });
      });
    };

    document.addEventListener("rebuy:cart.add", renderDialogContent);

    return () => {
      document.removeEventListener("rebuy:cart.add", renderDialogContent);
    };
  }
);
